const Setup = {
  benchmarksEdit: {
    title: 'Editar Benchmarks',
    description: 'Permite buscar Benchmarks pelo user group, acessar direto pela URL e editar a versão.',
    removePeriod: 'Atenção! Você tem certeza que deseja remover a data de expiração do período gratuito?',
    errorLoadList: 'Erro inesperado ao carregar lista de Benchmarks. Favor contactar o time de N2.',
    errorUnexpected: 'Erro inesperado! Por favor, refaça a operação.',
    cancel: 'Cancelar',
    save: 'Salvar',
    yes: 'Sim',
    no: 'Não',
    expired: 'Expirado em',
    yesConfirm: 'Sim. Tenho certeza.',
    editFreeTrial: 'Editar período gratuito',
    confirmFreeTrial: 'É uma versão gratuita?',
    chipExpiredIn: 'Expirado em {msg}',
    selectLabel: 'Selecione o período gratuito',
    expiredDate: 'Data expiração: {msg}',
  },
  newBenchmarks: {
    form: {
      benchmarksName: 'Nome do Benchmarks',
      userGroup: 'User Group',
      tooltip: 'Período de teste determinado',
      errorText: 'User Group não encontrado. Verifique se foi digitado corretamente.',
      textButtonRegister: 'Cadastrar',
      textButtonNext: 'Próximo',
      trialRadiosOptions: {
        text7days: '7 dias',
        text15days: '15 dias',
        text30days: '30 dias',
      },
    },
  },
};

export default Setup;
